import { apiClient } from '@/api/client';
import type { LoginPayload, LoginResponse } from '@/types/auth';

export async function login(payload: LoginPayload): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>(
    '/public/auth/login',
    payload,
  );
  return data;
}
